/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { useState } from 'react';
import {
    IconButton,
    DialogActions,
    Typography,
    Box,
    List,
    ListItem,
    CircularProgress,
    Tooltip,
    Button,
} from '@mui/material';
import { toast } from 'react-toastify';
import { getAssetLocationUserGrants } from '../../../../../services/assetLocation/assetLocationController';
import DialogContainer from '../../../../../components/shared/Dialog/DialogContainer';

const AssetLocationViewGrants = ({ userName }) => {
    const [open, setOpen] = useState(false);
    const [grants, setGrants] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleOpen = async () => {
        setOpen(true);
        setLoading(true);
        try {
            const data = await getAssetLocationUserGrants({ "username": userName });
            // Flatten the values of the objects into an array of strings
            const parsed = data.map((item) => {
                const key = Object.keys(item)[0];
                return item[key];
            });
            setGrants(parsed);
        } catch (error) {
            toast.error(error?.response?.data?.error?.message || 'Failed to fetch grants');
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setOpen(false);
        setGrants([]);
    };
    return (
        <>
            <Tooltip title="View Grants">
                <Button variant="outlined" color="primary" style={{ float: 'right' }} onClick={handleOpen}>View</Button>

            </Tooltip>

            <DialogContainer open={open} handleClose={handleClose}>
                <Box sx={{ mt: 2, px: 3 }}>
                    <Typography variant="h3" align="center" gutterBottom>
                        Grants for {userName}
                    </Typography>

                    {loading ? (
                        <Box display="flex" justifyContent="center" my={3}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <>
                            {grants.length === 0 ? (
                                <Typography align="center" color="text.secondary" sx={{ mb: 2 }}>
                                    No grants found for this user.
                                </Typography>
                            ) : (
                                <List dense>
                                    {grants.map((grant, index) => (
                                        <ListItem key={index} sx={{ fontSize: '14px' }}>
                                            <Typography variant="h6">  {grant}</Typography>
                                        </ListItem>
                                    ))}
                                </List>
                            )}
                        </>
                    )}

                    <DialogActions>
                        <IconButton onClick={handleClose}>Close</IconButton>
                    </DialogActions>
                </Box>
            </DialogContainer>
        </>
    );

}

export default AssetLocationViewGrants;
